// extracted by mini-css-extract-plugin
export default {"section":"ServicesSection_section__8VmWx"};